import { Link } from "react-router-dom";
import { Panel } from "../../components/ui";
import OfferCard from "./OfferCard";

export const ALL_OFFERS_PATH = "/partner/offers";

/**
 * What the office is running for its partners right now, newest first. Each card is a short
 * preview and the list scrolls on its own, so a long offer or a long list cannot push the rest of
 * the dashboard away. Absent when nothing is on, rather than an empty box.
 */
const OffersPanel = ({ offers }) => {
  if (!offers?.length) return null;
  return (
    <Panel
      title={offers.length === 1 ? "Current offer" : `Current offers (${offers.length})`}
      action={
        <Link
          to={ALL_OFFERS_PATH}
          className="shrink-0 text-xs font-semibold text-teal-700 no-underline hover:text-teal-800"
        >
          View all offers
        </Link>
      }
    >
      <ul
        className="list-none p-0 m-0 space-y-3 max-h-[32rem] overflow-y-auto pr-1"
        aria-label="Current offers"
      >
        {offers.map((offer) => (
          <OfferCard key={offer.id} offer={offer} />
        ))}
      </ul>
    </Panel>
  );
};

export default OffersPanel;
